import { Typography } from "@mui/material";
import i18n from "../../../../../i18n";
import styles from "./IdPhotosPanel.module.css";

type IdPhotosPanelProps = {
	idPhotoSrc: string;
	personPhotoSrc: string;
	handleImgError: (ev: React.SyntheticEvent<HTMLImageElement, Event>) => void;
};

export default function IdPhotosPanel({ idPhotoSrc, personPhotoSrc, handleImgError }: IdPhotosPanelProps) {
	return (
		<div className={styles.idPhotoPanel}>
			<div className={styles.idPhotoContainer}>
				<Typography variant="body1" fontWeight={600} color={"#FFFFFF"}>
					{i18n.t("result.components.resultsPage.proctoringResultsViewTSX.idPhoto")}
				</Typography>
				<img
					src={idPhotoSrc}
					alt={i18n.t("result.components.resultsPage.proctoringResultsViewTSX.idPhotoAlt")}
					onError={handleImgError}
					className={styles.idPhotoImage}
				/>
			</div>
			<div className={styles.idPhotoContainer}>
				<Typography variant="body1" fontWeight={600} color={"#FFFFFF"}>
					{i18n.t("result.components.resultsPage.proctoringResultsViewTSX.verificationPhoto")}
				</Typography>
				<img
					src={personPhotoSrc}
					alt={i18n.t("result.components.resultsPage.proctoringResultsViewTSX.verificationPhotoAlt")}
					onError={handleImgError}
					className={styles.idPhotoImage}
				/>
			</div>
		</div>
	);
}
